import { Component } from '@theme/component';

class ProductSkuComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      'change',
      this.#handleVariantChange,
      true
    );
  }

  disconnectedCallback() {
    document.removeEventListener(
      'change',
      this.#handleVariantChange,
      true
    );

    super.disconnectedCallback();
  }

  #handleVariantChange = async (event) => {
    const control = event.target.closest(
      'variant-picker input, variant-picker select'
    );

    if (!control) return;

    const picker = control.closest('variant-picker');

    if (!picker) return;

    let variantId = '';

    if (control.matches('input')) {
      variantId = control.dataset.variantId || '';
    }

    if (control.matches('select')) {
      variantId =
        control.selectedOptions?.[0]?.dataset?.variantId ||
        '';
    }

    if (!variantId) return;

    const productUrl =
      picker.dataset.productUrl ||
      window.location.pathname;

    try {
      const response = await fetch(
        `${productUrl.split('?')[0]}.js`
      );

      if (!response.ok) return;

      const product = await response.json();

      const variant = product.variants?.find(
        (item) =>
          String(item.id) === String(variantId)
      );

      if (!variant) return;

      const sku = String(
        variant.sku || ''
      ).trim();

      const topSku =
        document.querySelector('.ab-pdp__sku');

      if (topSku) {
        if (sku) {
          topSku.textContent = `SKU: ${sku}`;
          topSku.style.display = '';
        } else {
          topSku.textContent = '';
          topSku.style.display = 'none';
        }
      }

      document
        .querySelectorAll('[data-ab-product-sku]')
        .forEach((element) => {
          const fallback =
            element.dataset.fallbackModel || '';

          element.textContent =
            sku || fallback || '—';
        });
    } catch (error) {
      console.warn(
        '[AB SKU] Unable to update SKU',
        error
      );
    }
  };
}

if (
  !customElements.get(
    'product-sku-component'
  )
) {
  customElements.define(
    'product-sku-component',
    ProductSkuComponent
  );
} else {
  /*
   * The native component may already be registered,
   * so we still install the AB direct listener below.
   */
}

document.addEventListener(
  'change',
  async (event) => {
    const control = event.target.closest(
      'variant-picker input, variant-picker select'
    );

    if (!control) return;

    const picker = control.closest('variant-picker');

    if (!picker) return;

    let variantId = '';

    if (control.matches('input')) {
      variantId = control.dataset.variantId || '';
    }

    if (control.matches('select')) {
      variantId =
        control.selectedOptions?.[0]?.dataset?.variantId ||
        '';
    }

    if (!variantId) return;

    const productUrl =
      picker.dataset.productUrl ||
      window.location.pathname;

    try {
      const response = await fetch(
        `${productUrl.split('?')[0]}.js`
      );

      if (!response.ok) return;

      const product = await response.json();

      const variant = product.variants?.find(
        (item) =>
          String(item.id) === String(variantId)
      );

      if (!variant) return;

      const sku = String(
        variant.sku || ''
      ).trim();

      const topSku =
        document.querySelector('.ab-pdp__sku');

      if (topSku) {
        if (sku) {
          topSku.textContent = `SKU: ${sku}`;
          topSku.style.display = '';
        } else {
          topSku.textContent = '';
          topSku.style.display = 'none';
        }
      }

      document
        .querySelectorAll('[data-ab-product-sku]')
        .forEach((element) => {
          const fallback =
            element.dataset.fallbackModel || '';

          element.textContent =
            sku || fallback || '—';
        });
    } catch (error) {
      console.warn(
        '[AB SKU] Unable to update SKU',
        error
      );
    }
  },
  true
);